import { useTranslation } from "react-i18next";

export const useActivityTypeTranslation = () => {
  const { t } = useTranslation();

  const translateActivityType = (activityTypeId?: string): string => {
    if (!activityTypeId) return "";
    return t(activityTypeId, activityTypeId);
  };

  return { translateActivityType };
};
